import { toast } from "vue-sonner";
import { BaseToast } from "@/components/Base";
import { markRaw } from "vue";
import { generateUUID } from "@/utils/browser";

export const useCustomToast = () => {
  const showToast = (
    title: string,
    type: "success" | "error" | "warning" | "info",
  ) => {
    const id = generateUUID();

    toast.custom(markRaw(BaseToast), {
      id: id,
      componentProps: { title, type, id },
    });

    return id;
  };

  const dismissToast = (id: string) => {
    toast.dismiss(id);
  };

  return { showToast, dismissToast };
};
